import React from 'react';
import { FiArrowLeft } from 'react-icons/fi';
import { useDispatch, useSelector } from 'react-redux';
import BookMain from '../../page_book/BookMain';
import DigitalMain from '../../page_digital/DigitalMain';
import Exam2Main from '../../page_exam/Exam2Main';
import { setIsModalTestLms } from '../../reduxToolkit/redux';
import './DigitalLmsStudyViewer.scss';

const DigitalLmsStudyViewer = ({ device }) => {
  const dispatch = useDispatch();
  const isOpen = useSelector((state) => state.reduxStore.isModalTestLms);
  const selectedBookCode = useSelector((state) => state.reduxStore.selectedBookCode);
  const selectedBookName = useSelector((state) => state.reduxStore.selectedBookName);
  const bookTestKind = useSelector((state) => state.reduxStore.bookTestKind);

  if (!isOpen || !bookTestKind) return null;

  return (
    <div className={`digital-lms-study-viewer is-${device}`}>
      <header className="digital-lms-study-viewer__header">
        <button
          type="button"
          onClick={() => dispatch(setIsModalTestLms(false))}
          aria-label="학습 상세로 돌아가기"
        >
          <FiArrowLeft aria-hidden="true" />
        </button>
        <div>
          <span>{bookTestKind === 'TEST' ? '진단평가' : '디지털 학습'}</span>
          <strong>{selectedBookName}</strong>
        </div>
      </header>

      <div
        className={`digital-lms-study-viewer__content${bookTestKind === 'TEST' ? ' is-test-content' : ''}`}
      >
        {bookTestKind === 'TEST' && (
          <Exam2Main selectedItem={{ value: selectedBookCode }} />
        )}
        {bookTestKind === '출판물' && (
          <BookMain selectedItem={{ bookCode: selectedBookCode }} />
        )}
        {bookTestKind === '디지털' && (
          <DigitalMain selectedItem={{ bookCode: selectedBookCode }} />
        )}
      </div>
    </div>
  );
};

export default DigitalLmsStudyViewer;
